export const CONNECTION_ACCEPTED = 'Accepted';
export const CONNECTION_PENDING = 'Pending';
export const CONNECTION_DISCONNECTED = 'Disconnected';

export const connectionMeta = (connection) =>{
    if(!connection || !connection.meta){
        return null;
    }
    return typeof connection.meta === 'string' ?  JSON.parse(connection.meta) : connection.meta;
};

export const allowedToDownload = (connection) => {
    let meta = connectionMeta(connection);
    if(!meta){
        return false;
    }
    return meta.view_completed_docs;
};

export const connectionStatus = (connection) => {
    let meta = connectionMeta(connection);
    if(!!meta){
        if(meta.disconnected === true){
            return CONNECTION_DISCONNECTED;
        }else
        if(meta.accepted === true){
            return CONNECTION_ACCEPTED;
        }else{
            return CONNECTION_PENDING;
        }
    }
    return null;
}

export const userHasActionPending = (userUuid, connection) => {
    let meta = connectionMeta(connection);
    if(!meta){
        return false;
    }
    if(meta.requested_by === userUuid && connectionStatus(connection) === CONNECTION_PENDING){
        return false;
    }

    if(connectionStatus(connection) === CONNECTION_ACCEPTED){
        return true;
    }
    
    return connection.userUuid === userUuid || connection.modelUuid === userUuid;
}
